import { observer } from 'mobx-react-lite'
import { Outlet, useLocation } from 'react-router'
import { useEffect } from 'react'
import { IconButton } from 'shared/ui'
import { layoutStore } from 'shared/layout'
import { AdditionalBreakpointsEnum } from 'shared/constants/breakpoints'
import { useChatbotLayoutContext } from 'pages/chatbot/context/chatbotLayoutContext'
import { useUnifiedAgentContext } from 'pages/chatbot/ui/UnifiedAgent/context/unifiedAgentContext'
import { Header } from 'pages/chatbot/ui/UnifiedAgent/ui/Header/Header'
import { AgentConfigureTabs } from 'pages/chatbot/ui/UnifiedAgent/ui/AgentConfigureTabs/AgentConfigureTabs'
import { TestAgent } from 'pages/chatbot/ui/UnifiedAgent/ui/TestAgent/TestAgent'
import styles from './styles.module.scss'

export const UnifiedAgentContent = observer(() => {
  const chatbotLayoutStore = useChatbotLayoutContext()
  const { setCustomCollapseWidth } = chatbotLayoutStore.pageLayoutStore
  const { testAgentStore } = useUnifiedAgentContext()
  const isDesktop = !layoutStore.isAdditionalXSView
  const { state } = useLocation()

  useEffect(() => {
    setCustomCollapseWidth(AdditionalBreakpointsEnum['1280'])
    return () => {
      setCustomCollapseWidth(null)
    }
  }, [])

  useEffect(() => {
    if (state?.autoStartTest) {
      if (!isDesktop) testAgentStore.openModal()
      testAgentStore.start()
    }
  }, [])

  return (
    <>
      <Header />
      <div className={styles.wrap}>
        <div className={styles.left}>
          <div className={styles.tabsRow}>
            <AgentConfigureTabs />
          </div>
          <Outlet />
        </div>
        <div className={styles.right}>{isDesktop && <TestAgent />}</div>
      </div>
      {testAgentStore.isModalOpen && (
        <div className={styles.mobileWrap}>
          <div className={styles.overlay} onClick={testAgentStore.closeModal} />
          <div className={styles.mobilePanel}>
            <div className={styles.close}>
              <IconButton
                ariaLabel='close_test_agent'
                icon='close'
                variant='icon'
                color='secondary'
                onClick={testAgentStore.closeModal}
              />
            </div>
            <TestAgent isMobile />
          </div>
        </div>
      )}
    </>
  )
})
